<div class="ecommerceOrderDetailsMain">
  <div class="titleArea">
    <h3>
      {{ ecommerceOrder?.remoteOrderId }} <span *ngIf="ecommerceOrder.order_ID">{{ ecommerceOrder.order_ID }}</span>
    </h3>
    <p>
      <span i18n="@@Created">Created:</span> {{ formatDate(ecommerceOrder?.createdDate) }}
      <ng-container *ngIf="ecommerceOrder?.dateStartedProduction && ecommerceOrder?.dateStartedProduction.getTime() > 0">
        <span i18n="@@Produced">Produced:</span> {{ formatDate(ecommerceOrder?.dateStartedProduction) }}
      </ng-container>
      <ng-container *ngIf="ecommerceOrder?.shippedTimestamp && ecommerceOrder?.shippedTimestamp.getTime() > 0">
        <!-- The colon is OUTSIDE the i18n span on purpose. @@Shipped is shared with the
             toolbar filter button and the summary card on the orders grid, where a
             trailing colon is wrong -- and the id, not the source text, is what the
             bundles are keyed on, so one value has to serve all three. -->
        <span i18n="@@Shipped">Shipped</span><span>:</span> {{ formatDate(ecommerceOrder?.shippedTimestamp) }}
      </ng-container>
    </p>
    <div *ngIf="ecommerceOrder.releaseStatus === 'READY'" class="releaseButton">
      <button (click)="relase($event.target)" mat-raised-button color="accent" i18n="@@Release">Release</button>
    </div>
  </div>
<!--  <div>BookOrder[{{ JSON.stringify(ecommerceOrder.bookorder) }}]</div>-->
<!--  <div>FacilityOptions[{{ JSON.stringify(ecommerceOrder.facilityOptions) }}]</div>-->
  <div class="detailsArea">
    <div class="orderDetails">
      <h2><span i18n="@@Order Details">Order Details</span></h2>

      <!-- templates used by both the table and the narrow stacked div element versions -->
      <ng-template #idTemplate let-item>
        <ng-container *ngIf="item && !(item.source && (item.source === 'CSV' || item.source === 'ADDED_MANUALLY') )">
          <div>{{ item.title }}</div>
          <div class="secondary-info">{{ item.remoteProductId }}</div>
          <div *ngIf="item.ecommerceProductId" class="secondary-info">{{ item.ecommerceProductId }}</div>
          <div *ngIf="item.sku" class="secondary-info">{{ item.sku }}</div>
          <!--          <div class="secondary-info">{{ JSON.stringify(item) }}</div>-->
        </ng-container>
      </ng-template>

      <ng-template #selectProductTemplate let-item>
        <div *ngIf="!itemSelectionData" class="secondary-info" i18n="@@Loading products">Loading products...</div>
        <ng-container *ngIf="itemSelectionData">
          <div *ngIf="itemSelectionData.product" class="floatContainer" style="margin-bottom: 0px">
            <h5 style="margin-bottom: 0px" i18n="@@Selected Product">Selected Product</h5>
            <span *ngIf="itemSelectionData.product">{{itemSelectionData.product.title}}</span><button class="floatStart" style="background-color: transparent; border: none" *ngIf="itemSelectionData.product" i18n-title="@@UnSetTheSelectedProduct" title="Clear the selected product" (click)="itemSelectionData.setProduct(undefined); verifyAllProductsAreMapped();"><mat-icon>close</mat-icon></button>
            <div class="secondary-info" *ngIf="getCustomerProductId(itemSelectionData.product)">{{ getCustomerProductId(itemSelectionData.product) }}</div>
          </div>
          <div class="matchSource secondary-info" *ngIf="itemSelectionData.searchTerms.length > 0">
            <span i18n="@@Matching on">Matching on:</span> {{ itemSelectionData.searchTerms.join(' / ') }}
          </div>
          <div *ngIf="itemSelectionData.possibleMatches && itemSelectionData.possibleMatches.length > 0">
            <h5 style="margin-bottom: 0px" i18n="@@Best Matches">Best Matches</h5>
            <mat-chip-listbox>
              <mat-chip-option [selected]="possibleMatch.product === itemSelectionData.product" *ngFor="let possibleMatch of itemSelectionData.getBestPossibleMatches( 6 )" (click)="itemSelectionData.setProduct(possibleMatch.product)" [style.background-color]="getBackgroundColor(possibleMatch.score)" [style.--mdc-chip-elevated-container-color]="getBackgroundColor(possibleMatch.score)" [style.--mdc-chip-label-text-color]="getColor(possibleMatch.score)" style="height: auto;">
                <span class="chipLine">{{ possibleMatch.product?.ID }} - {{possibleMatch.product?.title}}</span>
                <span class="chipLine chipCode" *ngIf="getCustomerProductId(possibleMatch.product)">{{ getCustomerProductId(possibleMatch.product) }}</span>
                <span class="chipLine chipCode" *ngIf="possibleMatch.exact" i18n="@@Exact code match">Exact code match</span>
                <span class="chipLine chipCode chipWarn" *ngIf="possibleMatch.nearExact" i18n-title="@@nearExactCodeMatchHint" title="The codes are the same only if case and punctuation are ignored. Automatic matching on future orders is exact, so those orders will not map on their own until the codes are made identical." i18n="@@Differs by case or punctuation">Differs by case or punctuation</span>
              </mat-chip-option>
            </mat-chip-listbox>
          </div>
          <div *ngIf="itemSelectionData.searchTerms.length > 0 && itemSelectionData.possibleMatches.length === 0" class="secondary-info" i18n="@@No likely matches were found. Search the full catalog below.">No likely matches were found. Search the full catalog below.</div>
          <div>
            <mat-select style="width: 70%; padding-top: 8px;" #productId i18n-placeholder="@@Select a product" placeholder="Select a product" [ngModel]="itemSelectionData.product" (selectionChange)="itemSelectionData.setProduct(productId.value); verifyAllProductsAreMapped()" (openedChange)="onProductSelectOpened($event)" [ngModelOptions]="{standalone: true}">
              <!-- The search box has to live in the panel, not in mat-select-trigger:
                   trigger content renders on the closed control, so as a trigger it
                   was never visible at the moment you would want to type in it. -->
              <div class="product-search-box" (click)="$event.stopPropagation()" (keydown)="onSearchKeydown($event)">
                <mat-form-field appearance="fill" class="product-search-field">
                  <input matInput #searchInput i18n-placeholder="@@Search products" placeholder="Search products" [value]="productSearchText" (input)="onSearch(searchInput.value)">
                  <button mat-icon-button *ngIf="productSearchText" matSuffix i18n-title="@@Clear Search" title="Clear search" (click)="clearSearch($event)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <mat-option [class.selected]="!itemSelectionData.product" [value]="undefined" i18n="@@No Product Selected">No Product Selected</mat-option>
              <mat-option class="twoLineOption" [class.selected]="itemSelectionData.product && itemSelectionData.product === product" *ngFor="let product of filteredProducts" [value]="product">
                <span class="optionLine">{{product.title}}</span>
                <span class="optionLine option-secondary" *ngIf="getCustomerProductId(product)">{{ getCustomerProductId(product) }}</span>
              </mat-option>
              <div class="product-search-empty" *ngIf="filteredProducts.length === 0" i18n="@@No products match the search">No products match the search</div>
            </mat-select>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #productTemplate let-item>
        <ng-container *ngIf="editingProduct?.remoteProductId === item.remoteProductId">
          <ng-container *ngTemplateOutlet="selectProductTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>
        <ng-container *ngIf="editingProduct?.remoteProductId !== item.remoteProductId">
          <ng-container *ngIf="item.productId">
            <div *ngIf="getProduct(item.productId)?.title" class="secondary-info">{{ getProduct(item.productId)?.title }}</div>
            <div *ngIf="getCustomerProductId(getProduct(item.productId))" class="secondary-info">{{ getCustomerProductId(getProduct(item.productId)) }}</div>
            <div class="secondary-info">{{ item.productId }}</div>
            <div *ngIf="facilityInventoryProductsByProductIdAndFacility[ecommerceOrder.bookorder.facilityId + '_' + item.product_ID ]">{{facilityInventoryProductsByProductIdAndFacility[ecommerceOrder.bookorder.facilityId + '_' + item.product_ID ]?.title}}</div>
            <div *ngIf="usesEcommerceProductMapping && !(item.source === 'CSV' || item.source === 'ADDED_MANUALLY') && (item.ecommerceProductId === 0 || (item.ecommerceProduct && item.ecommerceProduct.product_ID !== item.productId ) )" i18n="@@Not using an standard ecommerce product ">Not using an standard ecommerce product</div>
          </ng-container>
          <ng-container *ngIf="!item.productId">
            <div i18n="@@Select a product" style="color: red">Select a product</div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!editingProduct && !editingQuantity && this.ecommerceOrder.releaseStatus !== 'SUCCESS'">
          <button mat-icon-button (click)="startProductEdit(item)" i18n-title="@@Edit Product" *ngIf="!(carrierServiceEditMode || customerEditMode)">
            <mat-icon>edit</mat-icon>
          </button>
        </ng-container>
        <ng-container *ngIf="editingProduct && editingProduct.remoteProductId === item.remoteProductId">
          <button mat-icon-button (click)="saveProductEdit(item)" [disabled]="!isProductEditDirty" i18n-title="@@Save Changes">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-icon-button (click)="cancelProductEdit()" i18n-title="@@Cancel Edit">
            <mat-icon>cancel</mat-icon>
          </button>
          <!-- Should changes be applied to an EcommerceProduct. Only offered when
               the connection actually resolves lines through one; the direct-to-
               Product modes leave ecommerceProductId at 0. -->
          <ng-container *ngIf="usesEcommerceProductMapping && item.remoteProductId && isProductEditDirty">
            <mat-checkbox color="primary" [checked]="saveProductSelectionToEcommerceProduct" (change)="toggleSaveProductSelectionToEcommerceProduct()" i18n="@@Apply Changes To Future Orders With the Same Remote ProductId">Apply Changes To Future Orders With the Same Remote ProductId</mat-checkbox>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #quantityTemplate let-item>
        <ng-container *ngIf="item.quantity > 0">
          <ng-container *ngIf="!editingQuantity">
            {{ item.quantity }}
          </ng-container>
          <mat-form-field *ngIf="editingQuantity && editingQuantity.remoteProductId === item.remoteProductId">
            <input matInput type="number" [formControl]="itemQuantityForm">
            <mat-error *ngIf="itemQuantityForm.hasError('required')" i18n="@@Quantity is required.">Quantity is required.</mat-error>
            <mat-error *ngIf="itemQuantityForm.hasError('min')" i18n="@@Quantity must be at least 1.">Quantity must be at least 1.</mat-error>
          </mat-form-field>
          <ng-container *ngIf="!editingProduct && !editingQuantity && this.ecommerceOrder.releaseStatus !== 'SUCCESS'">
            <button mat-icon-button (click)="startQuantityEdit(item)" i18n-title="@@Edit Product" *ngIf="!(carrierServiceEditMode || customerEditMode)">
              <mat-icon>edit</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="editingQuantity && editingQuantity.remoteProductId === item.remoteProductId">
            <button mat-icon-button (click)="saveQuantityEdit(item)" [disabled]="!isQuantityEditDirty" i18n-title="@@Save Changes">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button (click)="cancelQuantityEdit()" i18n-title="@@Cancel Edit">
              <mat-icon>cancel</mat-icon>
            </button>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #deleteItemTemplate let-item>
        <ng-container  *ngIf="this.ecommerceOrder.releaseStatus !== 'SUCCESS'">
          <!-- Gated on isIgnoredItem() rather than `quantity == 0` so the two
               buttons stay mutually exclusive against the same definition the
               server uses. A dismissed line now carries status 'IGNORE' as well
               as quantity 0; keying off quantity alone would show the wrong
               affordance for any line where only one of the two was set. -->
          <ng-container *ngIf="isIgnoredItem(item) && !customerEditMode && !editingQuantity && !editingProduct && !carrierServiceEditMode">
            <button mat-icon-button (click)="restoreItem(item)" i18n-title="@@Restore Item"><mat-icon>restore_from_trash</mat-icon></button>
          </ng-container>
          <ng-container *ngIf="!isIgnoredItem(item) && !customerEditMode && !editingQuantity && !editingProduct && !carrierServiceEditMode">
            <button mat-icon-button (click)="deleteItem(item)" i18n-title="@@Delete Item"><mat-icon>delete</mat-icon></button>
          </ng-container>
        </ng-container>
      </ng-template>

      <!-- Narrow screen version -- no table but stacked div elements -->
      <div class="stackedProducts" *ngIf="narrowDisplay">
        <div *ngFor="let item of ecommerceOrder?.bookorder?.items" class="stackedProduct" [style.background-color]="item['quantity'] === 0 ? 'grey' : (item['productId'] > 0 ? (!(item['source'] && (item['source'] === 'CSV' || item['source'] === 'ADDED_MANUALLY') ) && item['ecommerceProductId'] > 0 ? 'lightgreen': 'yellow') : 'pink')">
          <div class="group" data-label="Ecommerce Product" i18n-data-label="@@Ecommerce Product">
            <div class="content">
              <ng-container *ngTemplateOutlet="idTemplate; context: { $implicit: item }"></ng-container>
            </div>
          </div>
          <div class="group" data-label="Product" i18n-data-label="@@Product">
            <div class="content">
              <ng-container *ngTemplateOutlet="productTemplate; context: { $implicit: item }"></ng-container>
            </div>
          </div>
          <div class="group-wrapper">
            <div class="group" data-label="Quantity" i18n-data-label="@@Quantity">
              <div class="content">
                <ng-container *ngTemplateOutlet="quantityTemplate; context: { $implicit: item }"></ng-container>
              </div>
            </div>
          </div>
          <div class="group-wrapper">
            <div class="group" data-label="Delete Item" i18n-data-label="@@Delete Item">
              <div class="content">
                <ng-container *ngTemplateOutlet="deleteItemTemplate; context: { $implicit: item }"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Wide screen version -- use a table -->
      <ng-container *ngIf="!narrowDisplay">
        <table mat-table [dataSource]="ecommerceOrder?.bookorder?.items" class="products-table">
          <ng-container matColumnDef="ecommerceProduct">
            <th mat-header-cell *matHeaderCellDef i18n="@@Ecommerce Product">Ecommerce Product</th>
            <td mat-cell *matCellDef="let item">
              <ng-container *ngTemplateOutlet="idTemplate; context: { $implicit: item }"></ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="product">
            <th mat-header-cell *matHeaderCellDef i18n="@@Product">Product</th>
            <td mat-cell *matCellDef="let item">
              <ng-container *ngTemplateOutlet="productTemplate; context: { $implicit: item }"></ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef i18n="@@Quantity">Quantity</th>
            <td mat-cell *matCellDef="let item">
              <ng-container *ngTemplateOutlet="quantityTemplate; context: { $implicit: item }"></ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="deleteItem">
            <th mat-header-cell *matHeaderCellDef i18n="@@Delete Item">Delete Item</th>
            <td mat-cell *matCellDef="let item">
              <ng-container *ngTemplateOutlet="deleteItemTemplate; context: { $implicit: item }"></ng-container>
            </td>
          </ng-container>

<!--          <ng-container matColumnDef="status">-->
<!--            <th mat-header-cell *matHeaderCellDef i18n="@@Status">Status</th>-->
<!--            <td mat-cell *matCellDef="let item">-->
<!--              <ng-container *ngTemplateOutlet="statusTemplate; context: { $implicit: item }"></ng-container>-->
<!--            </td>-->
<!--          </ng-container>-->

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr [style.background-color]="row['quantity'] === 0 ? 'grey' : (row['productId'] > 0 ? (!(row.source && (row.source === 'CSV' || row.source === 'ADDED_MANUALLY') ) && row['ecommerceProductId'] > 0 ? 'lightgreen': 'yellow') : 'pink')" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </ng-container>
      <div class="addItem" *ngIf="this.ecommerceOrder.releaseStatus !== 'SUCCESS'">
        <button *ngIf="!customerEditMode && !editingQuantity && !editingProduct && !carrierServiceEditMode" mat-icon-button color="primary" (click)="addItem()" i18n-title="@@Add Item"><mat-icon>add</mat-icon></button>
      </div>
    </div>
    <div class="customerAndBillingDetails">
      <div class="customer">
        <h2><span i18n="@@Customer">Customer</span>
          <ng-container *ngIf="this.ecommerceOrder.releaseStatus !== 'SUCCESS'">
            <button *ngIf="!customerEditMode && !editingQuantity && !editingProduct && !carrierServiceEditMode" mat-icon-button (click)="startEditCustomerDetails()" class="edit-address-button" i18n-title="@@EditAddress"><mat-icon>edit</mat-icon></button>
            <button *ngIf="customerEditMode" mat-icon-button color="primary" (click)="saveCustomerDetails()" [disabled]="!( this.ecommerceOrder && this.addressValidationOrder && this.addressValidationOrder.isDirty && this.addressValidationOrder.canUseSelectedAddress() )" i18n-title="@@Save"><mat-icon>save</mat-icon></button>
            <button *ngIf="customerEditMode" mat-icon-button (click)="cancelCustomerEdit()" i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel"><mat-icon>cancel</mat-icon></button>
          </ng-container>
        </h2>
        <div *ngIf="!customerEditMode">
          <div class="addressLine">{{ ecommerceOrder?.title }} {{ ecommerceOrder?.firstname }} {{ ecommerceOrder?.lastname }}</div>
          <div class="addressLine" *ngIf="ecommerceOrder?.company">{{ ecommerceOrder?.company }}</div>
          <div class="addressLine">{{ ecommerceOrder?.address1 }}<span *ngIf="ecommerceOrder?.address2">, {{ ecommerceOrder?.address2 }}</span></div>
          <div class="addressLine">{{ ecommerceOrder?.city }}, {{ ecommerceOrder?.state }} {{ ecommerceOrder?.postalcode }}</div>
          <div class="addressLine">{{ ecommerceOrder?.country }}</div>
        </div>
        <ng-container *ngIf="customerEditMode">
          <app-address [addressValidationOrder]="addressValidationOrder"></app-address>
        </ng-container>
        <div class="shipping">
          <h2><span i18n="outbound delivery|Delivery of the order to the customer. Not Billing, and not the freight cost line.@@Shipping">Shipping</span>
            <ng-container *ngIf="this.ecommerceOrder.releaseStatus !== 'SUCCESS'">
              <button *ngIf="!carrierServiceEditMode && !(editingProduct || editingQuantity || customerEditMode)" mat-icon-button (click)="startEditCarrierService()" i18n-title="@@Edit Carrier and Service Level"><mat-icon>edit</mat-icon></button>
              <button *ngIf="carrierServiceEditMode" mat-icon-button color="primary" (click)="saveCarrierService()" [disabled]="!canSaveCarrierService()" i18n-title="@@Save"><mat-icon>save</mat-icon></button>
              <button *ngIf="carrierServiceEditMode" mat-icon-button (click)="cancelCarrierServiceEdit()" i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel"><mat-icon>cancel</mat-icon></button>
            </ng-container>
          </h2>
          <div *ngIf="!carrierServiceEditMode">{{ ecommerceOrder?.shippingInfo }}</div>
          <div *ngIf="carrierServiceEditMode">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Carrier and Service Level">Carrier & Service Level</mat-label>
              <mat-select [formControl]="carrierServiceForm">
                <!--
                  The trigger reads the SELECTED OPTION, not the raw control
                  value. It used to split the value on '_' inline, which both
                  mis-rendered the service levels that contain an underscore
                  (USPS_PRIORITY_FLAT read as "USPS PRIORITY") and showed
                  nothing at all for a value with no matching option -- the
                  exact case an operator opens this box to fix.
                -->
                <mat-select-trigger>
                  <ng-container *ngIf="getSelectedCarrierServiceLevelOption() as selectedCarrierServiceLevelOption">
                    {{ selectedCarrierServiceLevelOption.carrier | languageString }}
                    {{ selectedCarrierServiceLevelOption.serviceLevel | languageString }}
                    <span class="carrier-service-level-unrecognized" *ngIf="selectedCarrierServiceLevelOption.unrecognized" i18n="@@notRecognizedShippingOption">not recognized</span>
                  </ng-container>
                </mat-select-trigger>
                <mat-option *ngFor="let carrierServiceLevelOption of carrierServiceLevelOptions" [value]="carrierServiceLevelOption.id" [disabled]="carrierServiceLevelOption.unrecognized">
                  <div class="carrier-service-level-option-row">
                    <span class="carrier-service-level-left-col">{{carrierServiceLevelOption.carrier | languageString }}</span>
                    <span class="carrier-service-level-left-col">{{carrierServiceLevelOption.serviceLevel | languageString }}</span>
                    <span class="carrier-service-level-right-col">
                      <ng-container *ngIf="carrierServiceLevelOption.costKnown">{{carrierServiceLevelOption.cost | currency:'USD':'symbol':'1.2-2'}}</ng-container>
                      <span class="carrier-service-level-note" *ngIf="!carrierServiceLevelOption.costKnown && carrierServiceLevelOption.unrecognized" i18n="@@asImportedNotRecognized">as imported</span>
                      <span class="carrier-service-level-note" *ngIf="!carrierServiceLevelOption.costKnown && !carrierServiceLevelOption.unrecognized" i18n="@@shippingOptionNotPriced">not priced yet</span>
                    </span>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="carrier-service-level-hint" *ngIf="carrierServiceLevelOptionsSource === 'ALL_FACILITIES'" i18n="@@shippingOptionsPooledHint">No production facility has been settled for this order yet, so these are the options from every facility that could make it, at the lowest price any of them quoted. The price charged is worked out again after you save.</div>
            <div class="carrier-service-level-hint" *ngIf="carrierServiceLevelOptionsSource === 'CATALOG'" i18n="@@shippingOptionsCatalogHint">This order has never been priced, so every carrier and service level is offered here without a price. The price is worked out after you save, and an option the facility cannot provide is reported then.</div>
          </div>
        </div>
      </div>


      <div class="billingArea">
        <h2><span i18n="invoicing|Invoicing and payment details. Not Shipping.@@Billing">Billing</span></h2>
        <table class="revenueAndCostTable">
          <tr>
            <td></td>
            <td><span i18n="@@Revenue">Revenue</span></td>
            <td><span *ngIf="ecommerceOrder.releaseStatus === 'SUCCESS' || ecommerceOrder.releaseStatus === 'READY'" i18n="what we pay|Internal cost to produce or ship the item. Not the customer-facing Price. Confusing the two misreports margin.@@Cost">Cost</span></td>
          </tr>
          <tr>
            <td i18n="@@Product">Product</td>
            <td><span><span>{{ ecommerceOrder.productRevenue | currency }}</span></span></td>
            <td><span *ngIf="ecommerceOrder.releaseStatus === 'SUCCESS' || ecommerceOrder.releaseStatus === 'READY'">{{ ecommerceOrder.productionCost | currency }}</span></td>
          </tr>
          <tr>
            <td i18n="outbound delivery|Delivery of the order to the customer. Not Billing, and not the freight cost line.@@Shipping">Shipping</td>
            <td><span><span>{{ ecommerceOrder.shippingRevenue | currency }}</span></span></td>
            <td><span *ngIf="ecommerceOrder.releaseStatus === 'SUCCESS' || ecommerceOrder.releaseStatus === 'READY'">{{ ( ecommerceOrder.shippingCost + ecommerceOrder.packingCost ) | currency }}</span></td>
          </tr>
          <tr>
            <td i18n="@@Tax">Tax</td>
            <td><span><span>{{ ecommerceOrder.taxRevenue | currency }}</span></span></td>
            <td><span *ngIf="ecommerceOrder.releaseStatus === 'SUCCESS' || ecommerceOrder.releaseStatus === 'READY'">{{ ecommerceOrder.taxCost | currency }}</span></td>
          </tr>
          <tr>
            <td i18n="grand total|The final amount including shipping, handling and tax. Must be distinguishable from Subtotal.@@Total">Total</td>
            <td><span><span>{{ (ecommerceOrder.shippingRevenue + ecommerceOrder.productRevenue + ecommerceOrder.taxRevenue) | currency }}</span></span></td>
            <td><span *ngIf="ecommerceOrder.releaseStatus === 'SUCCESS' || ecommerceOrder.releaseStatus === 'READY'">{{ (ecommerceOrder.productionCost + ecommerceOrder.shippingCost + ecommerceOrder.packingCost + ecommerceOrder.taxCost) | currency }}</span></td>
          </tr>
        </table>
        <table class="revenueAndCostTable" *ngIf="(ecommerceOrder.releaseStatus === 'SUCCESS' || ecommerceOrder.releaseStatus === 'READY')">
          <tr>
            <td i18n="@@Total Margin">Margin Total</td>
            <td></td>
            <td><span [style.color]="( ( ecommerceOrder?.productRevenue + ecommerceOrder?.shippingRevenue + ecommerceOrder?.taxRevenue ) - ( ecommerceOrder?.productionCost + ecommerceOrder?.shippingCost + ecommerceOrder?.taxCost ) ) > 0 ? 'green' : 'red' ">{{ ( ( ecommerceOrder?.productRevenue + ecommerceOrder?.shippingRevenue + ecommerceOrder?.taxRevenue ) - ( ecommerceOrder?.productionCost + ecommerceOrder?.shippingCost + ecommerceOrder?.taxCost ) ) | currency }}</span></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>

